import { useState } from 'react'
import { Container, Paper, Title, TextInput, Button, Text, Anchor, Stack, Alert } from '@mantine/core'
import { useForm } from '@mantine/form'
import { useNavigate } from 'react-router-dom'
import { Info } from 'lucide-react'
import api from '../../api/client'

export function ForgotPassword() {
  const navigate = useNavigate()
  const [submitted, setSubmitted] = useState(false)
  const [loading, setLoading] = useState(false)

  const form = useForm({
    initialValues: { email: '' },
    validate: {
      email: (v) => (/^\S+@\S+$/.test(v) ? null : 'Enter a valid email address'),
    },
  })

  const handleSubmit = async (values: typeof form.values) => {
    setLoading(true)
    try {
      await api.post('/auth/forgot-password', { email: values.email.trim() })
    } catch {
      // Always show success message to avoid user enumeration
    } finally {
      setLoading(false)
      setSubmitted(true)
    }
  }

  return (
    <Container size={420} my={80}>
      <Title ta="center" style={{ color: 'var(--sat-text)' }}>Reset Password</Title>
      <Text c="dimmed" size="sm" ta="center" mt={5}>
        Remembered it?{' '}
        <Anchor size="sm" onClick={() => navigate('/login')}>Sign in</Anchor>
      </Text>

      <Paper withBorder shadow="md" p={30} mt={30} radius="md" bg="var(--sat-bg)">
        {submitted ? (
          <Stack>
            <Alert icon={<Info size={16} />} color="teal" radius="md">
              If this email is in our system, a password reset link has been sent. Please check your inbox and spam folder.
            </Alert>
            <Button fullWidth variant="outline" color="grapefruit" onClick={() => navigate('/login')}>
              Back to Login
            </Button>
          </Stack>
        ) : (
          <form onSubmit={form.onSubmit(handleSubmit)}>
            <Stack>
              <Text size="sm" c="dimmed">
                Enter your email address and we'll send you a link to reset your password.
              </Text>
              <TextInput
                label="Email"
                placeholder="you@example.com"
                required
                autoComplete="email"
                {...form.getInputProps('email')}
              />
              <Button fullWidth mt="xs" type="submit" color="grapefruit" loading={loading}>
                Send Reset Link
              </Button>
            </Stack>
          </form>
        )}
      </Paper>
    </Container>
  )
}
